<h6 class="d-flex align-items-center">
  <span>{{ field.Name }}</span>
  @if (field.Deprecation) {
    <mat-icon class="warning ml-2" [matTooltip]="field.Deprecation">warning</mat-icon>
  }
  @if (field.Description) {
    <mat-icon class="ml-2" [matTooltip]="field.Description">info</mat-icon>
  }
</h6>


<div class="main-container">
  <div class="line"></div>
  <div class="forms-container">
    <form [formGroup]="form">
      @for (field of fields; track field; let index = $index) {
        <div class="form-container" formArrayName="elements">
          <div class="plus-dots"></div>
          <!--  [formControl]="form.get('elements.' + index + '.key')" -->
          @if (form.get('elements.' + index); as formGroup) {
            <mat-form-field appearance="outline">
              <mat-label>Field name</mat-label>
              <input matInput type="string" [formControl]="formGroup.get('key')">
            </mat-form-field>
            <eva-ui-editor-element [field]="field" [formControl]="formGroup.get('value')"></eva-ui-editor-element>
          }
        </div>
      }
    </form>
    <div class="d-flex align-items-center">
      <div class="plus-dots"></div>
      <button mat-button (click)="addElement()">
        <mat-icon>add_circle_outline</mat-icon> ADD A FIELD
      </button>
    </div>
  </div>

</div>

